import { render, staticRenderFns } from "./EligibilityTasks.vue?vue&type=template&id=bd2f96be&"
import script from "./EligibilityTasks.vue?vue&type=script&lang=ts&"
export * from "./EligibilityTasks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports